<a
  *ngIf="destination !== null; else actionButton"
  mat-raised-button
  color="primary"
  class="ods-button"
  [routerLink]="destination"
>
  <mat-icon *ngIf="icon" fontSet="material-symbols-outlined" aria-hidden="true">{{ icon }}</mat-icon>
  {{ label }}
</a>
<ng-template #actionButton>
  <button mat-raised-button color="primary" class="ods-button" type="button" (click)="activated.emit()">
    <mat-icon *ngIf="icon" fontSet="material-symbols-outlined" aria-hidden="true">{{ icon }}</mat-icon>
    {{ label }}
  </button>
</ng-template>
